export interface BreachPathAppWebComponentSchema {
  // all the data needed for rendering
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnKeys {
  COMPANY = 'companyId',
  ISSUE_NAME = 'name',
  RESOURCE_NAME = 'mainResource.resourceName',
  RESOURCE_RISK_SCORE = 'scoreBreakdown.finalScore',
  RESOURCE_ID = 'mainResource.resourceId',
  CVES_COUNT = 'cveCount',
  RESOURCE_TYPE = 'mainResource.resourceType',
  PLATFORM = 'operatingSystem',
  CLOUD_ACCOUNT = 'cloudAccount',
  REGIONS = 'region',
  LAST_UPDATED = 'updatedAt',
  FIRST_FOUND = 'createdAt',
  IS_WATCHLIST = 'watchlist',
  SELECT = 'select',
}

export enum Column {
  COMPANY = 0,
  ISSUE_NAME = 1,
  RESOURCE_NAME = 2,
  RESOURCE_RISK_SCORE = 3,
  RESOURCE_ID = 4,
  CVES_COUNT = 5,
  RESOURCE_TYPE = 6,
  PLATFORM = 7,
  CLOUD_ACCOUNT = 8,
  REGIONS = 9,
  LAST_UPDATED = 10,
  FIRST_FOUND = 11,
  IS_WATCHLIST = 12,
  SELECT = 13,
}

export type BreachPathIssueRowData = {
  affectedResources: any[];
  cloudAccount: string;
  company: {
    name: string;
    specifics: {
      disableIorUserMonitoring: boolean;
    };
    features: {
      companionStandalone: boolean;
      edrUsable: boolean;
      edrVisible: boolean;
      eliteVisible: boolean;
      iorUsable: boolean;
      isolationUsable: boolean;
      patchManagementUsable: boolean;
    };
  };
  _id: string;
  companyId: string;
  createdAt: string;
  cveCount?: number;
  cves?: string[];
  mainResource: {
    resourceId: string;
    resourceName: string;
    resourceType: number;
  };
  misconfigurationCount?: number;
  name: number;
  operatingSystem: number;
  region: string;
  scoreBreakdown?: {
    baseScore: number;
    finalScore: number;
    multiplier: {
      applications: number;
      endpoints: number;
      users: number;
    };
  };
  status: number;
  updatedAt: string;
  watchlist: number;
}
